import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    {
        id: 1,
        label: 'MENUITEMS.DASHBOARDS.TEXT',
        icon: 'bx-home-circle',
        subItems: [
            {
                id: 2,
                label: 'MENUITEMS.DASHBOARDS.LIST.ADMIN',
                link: '/dashboard/admin',
                parentId: 1,
                roles: 10
            },
            {
              id: 3,
              label: 'MENUITEMS.DASHBOARDS.LIST.OPENCODE',
              link: '/dashboard/open-codes',
              parentId: 1,
              roles: 10
            },
            {
              id: 4,
              label: 'MENUITEMS.DASHBOARDS.LIST.PAYMENT',
              link: '/dashboard/payments',
              parentId: 1,
              roles: 10
            },
            {
              id: 5,
              label: 'MENUITEMS.DASHBOARDS.LIST.USERMANAGER',
              link: '/dashboard/user-manager',
              parentId: 1,
              roles: 20
          },
        ]
    },
    {
        id: 6,
        label: 'MENUITEMS.PROCESSES.TEXT',
        icon: 'bx-trending-up',
        isUiElement: true,
        subItems: [
            {
                id: 7,
                label: 'MENUITEMS.PROCESSES.LIST.SEND',
                link: '/processes/send/recorded',
                parentId: 6,
                roles: 10
            },
            {
                id: 8,
                label: 'MENUITEMS.PROCESSES.LIST.DELIVERING',
                link: '/processes/send/delivering',
                parentId: 6,
                roles: 10
            },
            {
                id: 9,
                label: 'MENUITEMS.PROCESSES.LIST.POSTED',
                link: '/processes/send/posted',
                parentId: 6,
                roles: 10
            },
            {
              id: 10,
              label: 'MENUITEMS.PROCESSES.LIST.DELIVERED',
              link: '/processes/send/delivered',
              parentId: 6,
              roles: 10
            },
            {
              id: 11,
              label: 'MENUITEMS.PROCESSES.LIST.DENIED',
              link: '/processes/send/denied',
              parentId: 6,
              roles: 10
            },
            {
              id: 12,
              label: 'MENUITEMS.PROCESSES.LIST.TIMEOUT',
              link: '/processes/send/timeout',
              parentId: 6,
              roles: 10
            },
            {
              id: 13,
              label: 'MENUITEMS.PROCESSES.LIST.RETURNED',
              link: '/processes/send/returned',
              parentId: 6,
              roles: 10
            },
            {
              id: 14,
              label: 'MENUITEMS.PROCESSES.LIST.RETURNING',
              link: '/processes/send/returning',
              parentId: 6,
              roles: 10
            },
            {
              id: 15,
              label: 'MENUITEMS.PROCESSES.LIST.GOTIT',
              link: '/processes/send/gotit',
              parentId: 6,
              roles: 10
            },
            {
              id: 16,
              label: 'MENUITEMS.PROCESSES.LIST.ROLLBACKED',
              link: '/processes/send/rollbacked',
              parentId: 6,
              roles: 10
            }
        ]
    },
    {
        id: 24,
        label: 'MENUITEMS.MAINTENANCE.TEXT',
        icon: 'bxs-wrench',
        subItems: [
            {
                id: 26,
                label: 'MENUITEMS.MAINTENANCE.LIST.RACK',
                link: '/maintenance/rack-maintenance',
                parentId: 24,
                roles: 20
            }
        ]
    },
    {
      id: 40,
      label: 'MENUITEMS.SYSTEM.TEXT',
      icon: 'bx-code-alt',
      subItems: [
        {
          id: 41,
          label: 'MENUITEMS.SYSTEM.LIST.CREATEHOST',
          link: '/system/create-host',
          parentId: 40,
          roles: 30
        },
        {
          id: 42,
          label: 'MENUITEMS.SYSTEM.LIST.REMOTECONTROL',
          link: '/system/remote-control',
          parentId: 40,
          roles: 30
        },
        {
          id: 43,
          label: 'MENUITEMS.SYSTEM.LIST.SYSTEMREPORT',
          link: '/system/system-report',
          parentId: 40,
          roles: 30
        },
        {
          id: 44,
          label: 'MENUITEMS.SYSTEM.LIST.HOSTSETTINGS',
          link: '/system/host-settings',
          parentId: 40,
          roles: 30
        },
        {
          id: 45,
          label: 'MENUITEMS.SYSTEM.LIST.PARTNERSETTINGS',
          link: '/system/partner-settings',
          parentId: 40,
          roles: 30
        },
        {
          id: 46,
          label: 'MENUITEMS.SYSTEM.LIST.STATISTICALREPORT',
          link: '/system/statistical-report',
          parentId: 40,
          roles: 30
        }
      ]
    }
];

